<template>
  <div class="incomeStatistics">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="form.agentName" placeholder="代理名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentAgentProfitList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
      <div class="total">
        <p>总交易奖励：<em>$--</em></p>
        <p>总层级奖励：<em>$--</em></p>
      </div>
    </div>
    <el-dialog title="二级代理月收益统计" :visible.sync="isTwoLevelIncomePop">
      <div class="pop-title"><p>代理A -代理B</p></div>
      <el-table :data="twoLevelTableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in twoLevelTableNav"></el-table-column>
      </el-table>
      <div class="pop-total">
        <p>总交易奖励：<em>$--</em></p>
        <p>总层级奖励：<em>$--</em></p>
      </div>
    </el-dialog>
    <el-dialog title="三级代理月收益统计" :visible.sync="isThreeLevelIncomePop">
      <div class="pop-title"><p>代理A -代理B -代理C</p></div>
      <el-table :data="threeLevelTableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in threeLevelTableNav"></el-table-column>
      </el-table>
      <div class="total">
        <p>总交易奖励：<em>$--</em></p>
        <p>总层级奖励：<em>$--</em></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'

  export default {
    name: 'incomeStatistics',
    data() {
      return {
        form: {
          agentName: ''
        },
        tableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '二级代理数', id: 'twoAgent' },
          { name: '三级代理数', id: 'threeAgent' },
          { name: '开始时间', id: 'startTime' },
          { name: '结束时间', id: 'endTime' },
          { name: '交易奖励', id: 'assignTradeAmount' },
          { name: '层级奖励', id: 'assignLevelAmount' }
        ],
        tableData: [],
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10, //当前页条数数
        isTwoLevelIncomePop: false,
        twoLevelTableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '开始时间', id: 'startTime' },
          { name: '结束时间', id: 'endTime' },
          { name: '交易奖励', id: 'assignTradeAmount' },
          { name: '层级奖励', id: 'assignLevelAmount' }
        ],
        twoLevelTableData: [],
        isThreeLevelIncomePop: false,
        threeLevelTableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '开始时间', id: 'startTime' },
          { name: '结束时间', id: 'endTime' },
          { name: '交易奖励', id: 'assignTradeAmount' },
          { name: '层级奖励', id: 'assignLevelAmount' }
        ],
        threeLevelTableData: []
      }
    },
    methods: {
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (rowIndex % 2 === 0) {
          if (columnIndex === 0) {
            return [1, 2]
          } else if (columnIndex === 1) {
            return [0, 0]
          }
        }
      },
      getSummaries(param) {
        console.log(param)
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价'
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 元'
          } else {
            sums[index] = 'N/A'
          }
        })

        return sums
      },
      getAgentProfitListData(data) {
        nationalMarketing.queryAgentProfitListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].startTime)) {
                  data[i].startTime = new Date(data[i].startTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].endTime)) {
                  data[i].endTime = new Date(data[i].endTime).format('Y-MM-dd hh:mm:ss')
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initAgentProfitListData() {
        let data = {
          type: 0,
          pageNum: this.currentPage
        }
        this.getAgentProfitListData(data)
      },
      changeCurrentAgentProfitList(val) {
        this.currentPage = val
        let data = {
          type: 0,
          pageNum: val
        }
        this.getAgentProfitListData(data)
      }
    },
    mounted() {
      this.initAgentProfitListData()
    }
  }
</script>

<style lang="scss" scoped>
  .incomeStatistics {
    margin: 20px;

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }

    .pop-title {
      margin-bottom: 20px;

      p {
        font-size: 16px;
        color: #409eff
      }
    }

    .total {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      p {
        display: block;
        font-size: 16px;
        margin-right: 30px;

        &:first-child {
          margin-left: 0
        }

        em {
          display: inline;
          color: #409eff
        }
      }
    }
  }
</style>
